import BaseApiClient from "./base-client";
class ConversationApi extends BaseApiClient {
    /**
     * Fetch conversation response by conversation ID.
     */
    getConversationResponse = async (conversationId) => {
        return this.get(`/api/conversation/${conversationId}/response`);
    };
    /**
     * Trigger async summary generation. Optionally pass custom guidelines.
     */
    regenerateSummary = async (conversationId, summaryGuidelines) => {
        return this.post(`/api/conversation/${conversationId}/summary/regenerate`, {
            data: { summaryGuidelines },
            _retry: { maxRetries: 3, delay: 1000, retryOn: [409] }
        });
    };
    /**
     * Generate summary guidelines for conversation task.
     */
    generateGuidelines = async (args) => {
        return this.post(`/api/conversation/summary-guidelines/generate`, { data: args });
    };
    static instance = new ConversationApi();
}
export default ConversationApi.instance;
